import { useEffect, useState, useRef } from 'react'
import { useRouter } from 'next/router'
import LocationSearch from '../hero/hero-rslhome/FromTo'
import Location from '../hero/hero-rslhome/AddressBookRideActivities'
import Skeleton from '@mui/material/Skeleton'
// import HotelDestinationCity from "../hero/hero-rslhome/TourDestinationCityHoliday";
import HotelDestinationCity from '../hero/hero-rslhome/staycation/ActivityDestinationCityStaycation'
import ActivityListStaycation from '../hero/hero-rslhome/staycation/ActivityListStaycation'
import HotelCalanderFrom from '../hero/hero-rslhome/TourCalanderFromHoliday'
import Autocomplete from '@mui/material/Autocomplete'
import CircularProgress from '@mui/material/CircularProgress'
import {
  searchStaycation,
  searchStaycationList
} from '../../redux/slices/staycation'
import { useDispatch, useSelector } from '../../redux/store'
import { createTheme, ThemeProvider } from '@mui/material/styles'

// Create a custom theme with the desired CircularProgress color
const customTheme = createTheme({
  components: {
    MuiCircularProgress: {
      styleOverrides: {
        root: {
          color: '#ffffff', // Change to your desired color
          width: '20px !important',
          height: '20px !important'
        }
      }
    }
  }
})

const ActivitiesRSL = () => {
  const router = useRouter()
  const dispatch = useDispatch()
  const autocompleteFirst = useRef()
  const autocompleteNext = useRef()
  const [bookPickUp, setBookPickUp] = useState(null)
  const [country, setCountry] = useState(null)
  const { staycationSearchRes, staycationSearchListRes } = useSelector(
    state => state.staycation
  )
  const [checkInDate, setCheckInDate] = useState('')
  const [checkOutDate, setCheckOutDate] = useState('')
  const [cityValue, setCityValue] = useState([])
  const [searchProduct, setSearchProduct] = useState([])
  const [selectedValue, setSelectedValue] = useState(null)
  const [cityValue1, setCityValue1] = useState([])
  const [searchProduct1, setSearchProduct1] = useState([])
  const [selectedValue1, setSelectedValue1] = useState(null)
  const [bookDropOff, setBookDropOff] = useState(null)
  const [stateCountry, setStateCountry] = useState('')
  const [loader, setLoader] = useState(false)
  const [loaderSearch, setLoaderSearch] = useState(false)
  const [isButtonDisabled, setIsButtonDisabled] = useState(false)
  const [pickup, setPickup] = useState({
    address: '',
    lat: 0,
    lng: 0
  })
  const [drop, setDrop] = useState({
    address: '',
    lat: 0,
    lng: 0
  })
  const [loading, setLoading] = useState(false)
  const [cityLoading, setCityLoading] = useState(false)
  const [focusFirst, setFocusFirst] = useState(true)
  const [focusNext, setFocusNext] = useState(false)

  const [isFormValid, setIsFormValid] = useState(true)
  const [errorMessage, setErrorMessage] = useState('')
  const [isSubmitClicked, setIsSubmitClicked] = useState(false)

  useEffect(() => {
    if (autocompleteFirst.current) {
      autocompleteFirst.current.querySelector('input').focus({ preventScroll: true })
    }
    dispatch(
      searchStaycation({ query: searchProduct.length > 0 ? searchProduct : '' })
    )
  }, [])

  useEffect(() => {
    if (selectedValue?.name !== '' && selectedValue !== null) {
      if (autocompleteNext.current) {
        autocompleteNext.current.querySelector('input').focus({ preventScroll: true })
        setFocusNext(true)
      }
    }
  }, [selectedValue])

  const [isCalled, setIsCalled] = useState(false)
  useEffect(() => {
    setCityLoading(true)
    setLoading(true)
    setIsCalled(true)
    const timerId = setTimeout(() => {
      if (searchProduct.length >= 3) {
        setCityValue([])
        dispatch(
          searchStaycation({
            query: searchProduct.length > 0 ? searchProduct : ''
          })
        )
      } else if (searchProduct.length === 0) {
        dispatch(searchStaycation({ query: '' }))
      }
    }, 500)

    return () => {
      clearTimeout(timerId)
    }
  }, [searchProduct])

  useEffect(() => {
    setLoading(true)
    setCityLoading(true)
    const timerId = setTimeout(() => {
      if (searchProduct.length >= 3) {
        setCityValue1([])
        dispatch(
          searchStaycationList({
            cityName: searchProduct.length > 0 ? searchProduct : '',
            search: searchProduct1.length > 0 ? searchProduct1 : ''
          })
        )
      }
    }, 500)

    return () => {
      clearTimeout(timerId)
    }
  }, [searchProduct1, searchProduct])

  useEffect(() => {
    setIsSubmitClicked(false)
    // if(countryValue&&countryValue!==""&&cityValue&&cityValue!==""&&checkInDate&&checkInDate!==""&&checkOutDate&&checkOutDate!==""){
    if (searchProduct && searchProduct.length !== 0 && searchProduct !== '') {
      setIsButtonDisabled(false)
    } else {
      setIsButtonDisabled(true)
    }
  }, [searchProduct, searchProduct1])

  const handleBookPickUpChange = e => {
    setBookPickUp(e.target.value)
  }

  const handleCountryChange = e => {
    setCountry(e.target.value)
  }

  const handleBookDropOffChange = selectedDropOffBook => {
    setBookDropOff(selectedDropOffBook)
  }

  const handleBooking = () => {
    setLoader(true)
    router.push({
      pathname: '/staycation/staycations',
      query: {
        cityName: selectedValue?.name,
        name: selectedValue?.name,
        checkIn: checkInDate,
        checkOut: checkOutDate
      }
    })
  }

  const handleBookingSearch = () => {
    setIsSubmitClicked(true)
    if (selectedValue?.name !== '' && selectedValue !== null) {
      setLoaderSearch(true)
      setLoader(true)
      router.push({
        pathname: '/staycation/staycations',
        query: {
          cityName: selectedValue?.name,
          name: selectedValue1?.name,
          checkIn: checkInDate,
          checkOut: checkOutDate,
          productId: selectedValue1?._id
        }
      })
    } else {
      setIsFormValid(false)
      setErrorMessage('Please fill in all fields.')
    }
  }

  useEffect(() => {
    if (isCalled) {
      if (staycationSearchRes !== undefined) {
        // Create an empty object
        setIsCalled(false)
        const myObjectDestination = {}
        const childArrayDestination = []
        const myObjectStaycationList = {}
        const childArrayStaycationList = []
        const allObjectDestination = {}
        const allArrayDestination = []
        const mainArray = []
        setCityLoading(false)
        setLoading(false)
        if (staycationSearchRes?.destination !== undefined) {
          if (staycationSearchRes?.destination.length > 0) {
            staycationSearchRes?.destination.map(data => {
              myObjectDestination.label = 'City'
              myObjectDestination.img = '/img/general/flag.png'
              childArrayDestination.push(data)
              myObjectDestination.values = childArrayDestination
              //
            })
          } else {
            myObjectDestination.label = 'City'
            myObjectDestination.values = []
          }
        }

        if (staycationSearchRes?.countryList !== undefined) {
          if (staycationSearchRes?.countryList.length > 0) {
            staycationSearchRes?.countryList.map(data => {
              myObjectStaycationList.label = 'Country'
              myObjectStaycationList.img = '/img/general/iconnew.png'
              childArrayStaycationList.push(data)
              myObjectStaycationList.values = childArrayStaycationList
              //
            })
          } else {
            myObjectStaycationList.label = 'Country'
            myObjectStaycationList.values = []
          }
        }

        if (staycationSearchRes?.allCityType !== undefined) {
          if (staycationSearchRes?.allCityType.length > 0) {
            staycationSearchRes?.allCityType.map(data => {
              allObjectDestination.label =
                data?.countryName || 'Matched Location'
              allObjectDestination.img = '/img/general/iconnew.png'
              allArrayDestination.push(data)
              allObjectDestination.values = allArrayDestination
              //
            })
          } else {
            allObjectDestination.label = 'Matched Location'
            allObjectDestination.values = []
          }
        }

        mainArray.push(
          allObjectDestination,
          myObjectDestination,
          myObjectStaycationList
        )
        setCityValue(mainArray)
      }
    }
  }, [staycationSearchRes])

  useEffect(() => {
    // if (tourSearchRes.length > 0) {
    if (staycationSearchListRes !== undefined) {
      // Create an empty object
      const myObjectDestination = {}
      const childArrayDestination = []
      const myObjectHolidayList = {}
      const childArrayHolidayList = []
      const mainArray = []
      setLoading(false)
      if (staycationSearchListRes?.topAttraction !== undefined) {
        if (staycationSearchListRes?.topAttraction.length > 0) {
          staycationSearchListRes?.topAttraction.map(data => {
            myObjectDestination.label = 'Top StayCation'
            myObjectDestination.img = '/img/general/flag.png'
            childArrayDestination.push(data)
            myObjectDestination.values = childArrayDestination
            //
          })
        } else {
          myObjectDestination.label = 'Top StayCation'
          myObjectDestination.values = []
        }
      }

      if (staycationSearchListRes?.staycationList !== undefined) {
        if (staycationSearchListRes?.staycationList.length > 0) {
          staycationSearchListRes?.staycationList.map(data => {
            myObjectHolidayList.label = 'StayCation'
            myObjectHolidayList.img = '/img/general/iconnew.png'
            childArrayHolidayList.push(data)
            myObjectHolidayList.values = childArrayHolidayList
            //
          })
        } else {
          myObjectHolidayList.label = 'StayCation'
          myObjectHolidayList.values = []
        }
      }
      if (staycationSearchListRes.staycationList.length === 0) {
        setSelectedValue1({
          name: ''
        })
      }

      mainArray.push(myObjectDestination, myObjectHolidayList)
      setCityValue1(mainArray)
    }
  }, [staycationSearchListRes])

  return (
    <>
      <div className='activites_rsl'>
        <div className='activites_input'>

          {/* <div className='Activities-rsl y-gap-40'> */}
          <div className='Activities Activities-new py-5'>
            {/* <Location
              placeholder="Search by Destination, Attraction or Activities"
              value={bookPickUp}
              bookPickUp={bookPickUp}
              setBookPickUp={setBookPickUp}
              setPickup={setPickup}
              pickup={pickup}
              onChange={(e) => setBookPickUp(e.target.value)}
            /> */}
            <HotelDestinationCity
              setCityValue={setCityValue}
              cityValue={cityValue}
              searchProduct={searchProduct}
              setSearchProduct={setSearchProduct}
              setSelectedValue={setSelectedValue}
              selectedValue={selectedValue}
              // label="Select your City?"
              label='Select your City?'
              placeholder='Search'
              setLoading={setCityLoading}
              loading={cityLoading}
              autocompleteFirst={autocompleteFirst}
              error={isSubmitClicked && selectedValue === null ? true : false}
              helperText={
                isSubmitClicked && selectedValue === null ? 'Required' : ''
              }
            />
            <ActivityListStaycation
              setCityValue={setCityValue1}
              cityValue={cityValue1}
              searchProduct={searchProduct1}
              setSearchProduct={setSearchProduct1}
              setSelectedValue={setSelectedValue1}
              selectedValue={selectedValue1}
              label='Attraction & Tours'
              placeholder='Search'
              setLoading={setLoading}
              loading={loading}
              autocompleteNext={autocompleteNext}
            // error={isSubmitClicked && selectedValue1 === null ? true : false}
            // helperText={isSubmitClicked && selectedValue1 === null ? 'Required' : ''}
            />
            <div className='trip-booking__btn'>
              <ThemeProvider theme={customTheme}>
                <button
                  className='mainSearch__submit btn-1 button -dark-4 py-10 px-15  bg-dark-3 text-white w-100'
                  onClick={handleBookingSearch}
                >
                  {loader ? <CircularProgress /> : 'Search'}
                </button>
              </ThemeProvider>
            </div>
            {/* <HotelCalanderFrom
            setCheckInDate={setCheckInDate}
            setCheckOutDate={setCheckOutDate}
            checkInDate={checkInDate}
            checkOutDate={checkOutDate}
          /> */}
            {/* <LocationSearch placeholder="Location" /> */}
            {/* <Autocomplete
      disablePortal
      id="combo-box-demo"
      options={countries}
      // value={country}
      setCountry={setCountry}
      setStateCountry={setStateCountry}
      stateCountry={stateCountry}
      onChange={(e) => setCountry(e.target.value)}
      renderInput={(params) => <TextField {...params} label="Country" />}
    /> */}
            {/* <Location
              placeholder="Search by Destination, Attraction or Activities"
              value={bookDropOff}
              bookDropOff={bookDropOff}
              setBookDropOff={setBookDropOff}
              setDrop={setDrop}
              onChange={(e) => setBookDropOff(e.target.value)}
            /> */}
          </div>
        </div>
      </div>
    </>
    // </div>
  )
}

export default ActivitiesRSL
